import { useNavigate } from "react-router-dom";
const LowestMinimumDeposit = ({ data }) => {
  const navigate = useNavigate();
  const casinos = data.map((c) => ({
    id: c.id,
    name: c.name,
    minDeposit: c.minDeposit,
  }));

  return (
    <section className="bg-background dark:bg-black text-black dark:text-white py-16 transition-colors duration-300">
      <div className="w-full mx-auto max-w-[1000px] px-6">
        {/* ===== Heading and Description ===== */}
        <div className="text-left mb-6">
          <h2 className="text-2xl sm:text-3xl font-bold pb-3 text-text dark:text-white">
            Casinos with the lowest minimum deposit
          </h2>
          <p className="text-base text-text/80 dark:text-white/70 mt-3">
            These casinos are perfect for casual gamers, featuring low minimum
            deposits and a wide variety of games. From timeless table games to
            exciting new video slots, players can dive into a vast selection of
            titles. Whether you enjoy poker, blackjack, or themed slots, there's
            something here for everyone without breaking the bank.
          </p>
        </div>

        {/* ===== Table ===== */}
        <div className="overflow-x-auto rounded-lg border border-border dark:border-gray-700 bg-surface dark:bg-gray-900 transition-colors duration-300">
          <table className="w-full text-sm text-left border-collapse">
            <thead className="text-text/70 dark:text-white/60 text-[13px] uppercase tracking-wide">
              <tr>
                <th className="px-4 py-3 font-semibold">Casino</th>
                <th className="px-4 py-3 font-semibold">Minimum Deposit</th>
                <th className="px-4 py-3 font-semibold text-right">Review</th>
              </tr>
            </thead>

            <tbody>
              {casinos.map((casino, i) => (
                <tr
                  key={i}
                  className="hover:bg-primary/5 dark:hover:bg-primary/20 transition-colors"
                >
                  <td className="px-4 py-3 font-medium">{casino.name}</td>
                  <td className="px-4 py-3">{casino.minDeposit}</td>

                  <td className="px-4 py-3 text-right">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        if (!casino?.name) return;
                        const slug = casino.name
                          .toLowerCase()
                          .replace(/\s+/g, "-");
                        navigate(`/${slug}-review`, { state: { casino } });
                      }}
                      type="button"
                      className="rounded-md border border-border dark:border-gray-700 bg-surface dark:bg-gray-800 px-3 py-1.5 text-sm font-medium text-text dark:text-white hover:bg-primary/10 dark:hover:bg-primary/20 transition-colors duration-300"
                    >
                      Full Review
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* ===== Footer Note ===== */}
        <p className="text-center text-text/70 dark:text-white/60 text-sm mt-6">
          Casinos we list with the lowest minimum deposit
        </p>
      </div>
    </section>
  );
};

export default LowestMinimumDeposit;
